import { SectionContainer } from '@/components/shared'
import { websiteContent } from '../content'
import { usePanelViewTracking } from '../hooks/usePanelViewTracking'

const { intro } = websiteContent

function IntroSection() {
  usePanelViewTracking({
    panelId: 'intro',
    panelName: 'Intro',
    panelIndex: 1,
  })

  return (
    <SectionContainer
      id="intro"
      size="page"
      className="bg-white min-h-[798px] py-[63px] md:min-h-0 md:py-20 xl:py-[200px] 3xl:py-[248px]"
      innerClassName="!px-10 md:!px-page-gutter xl:!px-content-inset 3xl:!px-content-inset-wide"
    >
      <div className="w-full max-w-[920px] space-y-[56px]">
        <p className="font-archivo text-[12px] font-extralight uppercase leading-[16px] text-gray-dark">
          {intro.title}
        </p>
        <h2 className="font-archivo text-[32px] font-extralight leading-[46px] text-black md:text-h2">
          {intro.subtitle}
        </h2>
        <p className="font-archivo text-[18px] font-light leading-[32px] text-gray-dark md:text-h3">
          {intro.description}
        </p>
      </div>
    </SectionContainer>
  )
}

export default IntroSection
